/**
 * Complete the Look Logic
 * Integrates with main product form to add multiple items at once.
 * Updated for List Layout
 */

class CompleteTheLook {
  constructor() {
    this.container = document.querySelector('.complete-the-look-section');
    if (!this.container) return;

    this.initVariantSelectors();
  }

  initVariantSelectors() {
    const selects = this.container.querySelectorAll('.ctl-variant-select');
    selects.forEach(select => {
      select.addEventListener('change', (e) => {
        const option = e.target.options[e.target.selectedIndex];
        const price = option.dataset.price;
        const comparePrice = option.dataset.comparePrice;
        const image = option.dataset.image;
        
        const card = e.target.closest('.ctl-product-card');
        const priceEl = card.querySelector('.ctl-current-price');
        const comparePriceEl = card.querySelector('.ctl-compare-price');
        const imgEl = card.querySelector('img');
        const checkbox = card.querySelector('.ctl-product-checkbox');

        if (priceEl) priceEl.innerText = price;
        if (comparePriceEl) {
          if (comparePrice) {
            comparePriceEl.innerText = comparePrice;
            comparePriceEl.style.display = 'block';
            priceEl.classList.add('on-sale');
          } else {
            comparePriceEl.style.display = 'none';
            priceEl.classList.remove('on-sale');
          }
        }
        if (imgEl && image) imgEl.src = image;
        
        // Update checkbox variant ID
        if (checkbox) {
          checkbox.dataset.variantId = option.value;
        }
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CompleteTheLook();
});
